import { Component } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { take } from "rxjs";
import { AppState } from "src/app/app.reducer";
import { AuthActions } from "src/app/shared/auth/auth.actions";
import {
  selectCurrentUser,
  selectIsLoggedIn,
} from "src/app/shared/auth/auth.selectors";
import { AuthService } from "src/app/shared/auth/auth.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: "app-public-header",
  templateUrl: "./public-header.component.html",
  styleUrls: ["./public-header.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatDividerModule,
  ],
})
export class PublicHeaderComponent {
  selectIsLoggedIn$ = this.store.select(selectIsLoggedIn);
  currentUser$ = this.store.select(selectCurrentUser);

  constructor(
    private store: Store<AppState>,
    private auth: AuthService,
  ) { }

  logout() {
    this.store.dispatch(AuthActions.logout());
  }
}
